module.exports = __webpack_public_path__ + "img/LTS_CISA.d8d7f5c5.gif";